export const resolveMediaUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  return `${process.env.REACT_APP_MEDIA_BASE_URL}${path}`;
};
